  <template>
    <div class="text-center col-12 d-lg-flex">
<!--      <img src="/themes/custom/timparty/images/portaunamico-blue.png" alt="" class="fit-image">-->
      <div class="codice-amico-holder">
        <h1 class="mb-5 mt-3">Benvenuto in Tim Party</h1>
        <div class="row justify-content-center">
          <h3 class="mb-3 mt-2">Hai ricevuto un Codice Amico?</h3>
          <button-badges-modal :custom-contest-active="$root.$refs.PortaUnAmico.customContestPresentato.active"
                               :custom-contest-html="$root.$refs.PortaUnAmico.customContestPresentato.html"
                               :custom-contest-image="$root.$refs.PortaUnAmico.customContestPresentato.image">
          </button-badges-modal>
        </div>

        <p class="mb-4">Il Codice Amico ha una validità di <span class="yellow-text" v-text="initiative.initiativeMgm.subscriptionDays"></span>
          <span class="yellow-text" v-if="initiative.initiativeMgm.subscriptionDays == 1"> giorno</span>
          <span class="yellow-text" v-else> giorni</span>
          dal tuo primo accesso su TIM Party, e comunque entro il termine dell’iniziativa. Inseriscilo subito nell’apposito box per richiedere il tuo vantaggio esclusivo.</p>
        <div class="codice-amico-box">
          <div class="row">
            <div class="col-lg-7" v-if="status === 'POTENTIAL_REFEREE'">
  <!--          <div class="col-lg-7" v-if="status === 'REFEREE'">-->
              <form>
                <div class="form-group" id="form-referral-code">
                  <label for="code">Codice Amico</label>
                  <input type="text" placeholder="Inserisci codice amico" id="code" v-model="referralCode">
                  <span class="d-none" id="error-referral">Codice Amico non valido. Riprova</span>
                </div>
                <button type="button" class="btn-primary" v-on:click="submitReferral">Conferma</button>
              </form>
            </div>
            <div class="col-lg-7" v-else-if="status === 'REFEREE' && initiative.userInformation.benefitStatus[refereeBenefit.benefitId] === 'REDEEMABLE'">
  <!--          <div class="col-lg-7" v-if="status === 'POTENTIAL_REFEREE'">-->
              <div class="referee-redeem-box text-left">
                <h5>Complimenti!</h5>
                <p>Hai a disposizione il tuo vantaggio.</p>
                <span>Puoi richiederlo fino al {{ formatTimestamp(initiative.initiativeMgm.endTime) }}</span>
                <button type="button" class="btn-primary mt-4 mb-2" v-on:click="submitRedeemBenefit">Richiedi</button>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="benefit-box">
                <div class="benefit-image">
                  <img v-bind:src="refereeBenefit.image" alt="" class="img-fluid">
                </div>
                <div class="benefit-description">
                  <h5><b v-html="refereeBenefit.title"></b></h5>
                  <p v-html="refereeBenefit.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <img src="/themes/custom/timparty/images/portaunamico-yellow-red.png" alt=""  class="fit-image">-->
    </div>
  </template>


  <script>
  import $                 from 'jquery';

  import TimPartyMixin     from "../mixins/TimPartyMixin";
  import ButtonBadgesModal from "./ButtonBadgesModal";

  export default {
    name: "PortaUnAmicoReferral",
    mixins: [ TimPartyMixin ],
    components: {
      ButtonBadgesModal,
    },
    props: {
      benefit: {
        type: Object,
        required: true
      },
      apiUrl: {
        type: String,
        default: '/api/mgm/handleAction',
      }
    },
    watch: {
      reload() {
        if (this.reload) {
          this.$root.$refs.PortaUnAmico.getInitiative();
          this.$root.$refs.PortaUnAmico.setRefereeBenefit();
          setTimeout(()=>{
            this.initiative = this.$root.$refs.PortaUnAmico.getInitiativeChild();
          },1500);

          this.reload = false;
        }
      },
      status() {},
      initiative() {
        if (this.test) {
          this.status = 'POTENTIAL_REFEREE';
        } else {
          this.status = this.initiative.userInformation.userType;
        }
        this.refereeBenefit = this.$root.$refs.PortaUnAmico.setRefereeBenefitChild();
        this.checkIfShowBanner();
      },
      showBanner() {
      }
    },
    data: function(){

      return {
        initiative: '',
        refereeBenefit: '',
        referralCode : '',
        reload: false,
        showBanner: false,
        status: '',
        test: false
      };
    },
    mounted: function() {
      this.setApiUrl(this.apiUrl);
      setTimeout(()=>{
        this.initiative = this.$root.$refs.PortaUnAmico.getInitiativeChild();
        this.refereeBenefit = this.$root.$refs.PortaUnAmico.setRefereeBenefitChild();
      },1500);
      // this.reload = true;
    },
    methods: {
      submitReferral: function() {
        let element = $(this);
        element.attr('disabled', 'disabled');
        let self = this;
        let payload = {
          action: 'burnCodeReferral',
          referral_code: this.referralCode
        };

        this.callApi( payload, function(response) {
          if (response !== [] && response.success) {
            self.reload = true;
            // self.test = true;
          } else {
            element.attr('disabled', false);
            $('#error-referral').removeClass('d-none');
            $('#form-referral-code').addClass('form-referral-code');
          }
          // self.initiative = response;
        });
      },

      submitRedeemBenefit: function() {
        $(this).attr('disabled', 'disabled');
        let self = this;
        let payload = {
          action: 'redeemBenefit',
          benefit_id: this.refereeBenefit.benefitId,
        };

        this.callApi( payload, function(response) {
          if (response.success) {
            let url = self.refereeBenefit.urlCta;
            window.location.href = url;
          } else {
            console.log('ko');
          }
        });
      },

      // setRefereeBenefit: function () {
      //   let self = this;
      //
      //   this.initiative.initiativeMgm.benefitList.forEach(function (benefit) {
      //     if(benefit.isBenefitReferee) {
      //       self.refereeBenefit = benefit;
      //     }
      //   })
      // },
      checkIfShowBanner: function () {
        let self = this;
        if(this.status === 'REFERRAL') {
          self.showBanner = false;
        } else if (this.initiative.userInformation.benefitStatus[this.refereeBenefit.benefitId] === 'REDEEMED') {
          self.showBanner = false;
        } else {
          self.showBanner = true;
        }
      },
      changeReload: function () {
        this.reload = true;
      }
    }
  }
  </script>
